
<idt-common-styles-render
  *ngIf="piece"
  [styles]="piece.settings?.styles">
  <div class="store-language-container">
    <select
      *ngIf="settings?.general?.allowCountryChange"
      (change)="selectStore($event)"
      name="store-selector"
      id="store-list">
      <option
        *ngFor="let store of stores; trackBy: trackByStore"
        [value]="store.countryCode"
        [selected]="selectedStore && store.countryCode === selectedStore?.countryCode">
        {{ store.countryName }}
      </option>
    </select>
    <div
      *ngIf="!settings?.general?.allowCountryChange && selectedStore"
      class="store-selector-ee-country">
      <span
        (click)="navigateToWorldwide($event)"
      >
        {{ selectedStore?.countryName }}
      </span>
    </div>
    <select
      *ngIf="!settings?.general?.detectLanguage && settings?.general?.comboSelector"
      (change)="onChangeLanguage($event)"
      name="language-selector"
      id="store-languages">
      <option
        *ngFor="let language of languages; trackBy: trackByLanguage"
        [value]="language.code">
        {{ language.name }}
      </option>
    </select>
    <div
      class="store-selector-ee-language-list"
      *ngIf="!settings?.general?.comboSelector">
      <div
        *ngFor="let language of languages; trackBy: trackByLanguage"
        class="store-selector-ee-language-list-item"
        [class.store-selector-ee-language-list-item--selected]="selectedLanguage?.code === language.code">
        <span (click)="clickLanguage($event, language.code)">
          {{ language.name }}
        </span>
      </div>
    </div>
    <render-button
      *ngIf="settings?.general?.comboSelector"
      (click)="goToHome($event)"
      [customClass]="'e2e-submit-store-language'">
      Enviar
    </render-button>
  </div>
</idt-common-styles-render>
